module.exports = __webpack_public_path__ + "static/media/polus2.bfe92ef2.jpg";